import { capitalize } from 'lodash';
import { SingleEventType } from '../core/TimeData';

export const singleEventTypes = [
  SingleEventType.MANEUVERING,
  SingleEventType.BUNKERING,
  SingleEventType.CLEANING,
  SingleEventType.DRIFTING,
  SingleEventType.WAITING,
  SingleEventType.CONGESTION,
  SingleEventType.PASSING,
  SingleEventType.REPAIR,
  SingleEventType.CANAL_TRANSIT,
  SingleEventType.OTHER,
].map((type) => ({
  type,
  label: capitalize(SingleEventType[type].replace('_', ' ')),
}));
